import { EAdvancedFilterType } from 'shared/enums/EAdvancedFilterType';
import { hasTradeAreaOfficeType } from 'shared/utils/filters/hasTradeAreaOfficeType';
import { hasTwoOfficeTypes } from 'shared/utils/filters/hasTwoOfficeTypes';
import { includesOfficeType } from 'shared/utils/filters/includesOfficeType';

import { IFiltersService } from '../../IFiltersService';

import { AbstractAdvancedFiltersService } from './AbstractAdvancedFiltersService';

/**
 * @description Сервис для категории "Офис + Торговая площадь". Не имеет значение аренда или продажа
 */
export class AnyOfficeTradeAreaAdvancedFiltersService
  extends AbstractAdvancedFiltersService
  implements IFiltersService<EAdvancedFilterType>
{
  public isAvailable(): boolean {
    return [hasTwoOfficeTypes, includesOfficeType, hasTradeAreaOfficeType].every(fn => fn(this.filters));
  }

  public getFields(): EAdvancedFilterType[] {
    return super
      .getFields()
      .concat(
        EAdvancedFilterType.floor,
        EAdvancedFilterType.floorTypes,
        EAdvancedFilterType.floorn,
        EAdvancedFilterType.inputType,
        EAdvancedFilterType.buildingClassType,
        EAdvancedFilterType.buildingHouseLine,
        EAdvancedFilterType.conditionType,
        EAdvancedFilterType.contract,
        EAdvancedFilterType.furniture,
        EAdvancedFilterType.houseYear,
        EAdvancedFilterType.parkingType,
        EAdvancedFilterType.infrastructure,
        EAdvancedFilterType.commissionType,
        EAdvancedFilterType.withoutAgentCall,
        EAdvancedFilterType.buildingType,
        EAdvancedFilterType.electronicTrading,
      );
  }
}
